import apiClient from "./apiClient";

const API_URL = `/kardex/nursing-care`;

export const createCare = async (careData) => {
  // apiClient will automatically add organizationId via interceptor
  const response = await apiClient.post(`${API_URL}/create-care`, careData);
  return response.data;
};

export const getNursingByAdmissionId = async (admissionId) => {
  try {
    // apiClient will automatically add organizationId as query param via interceptor
    const response = await apiClient.get(`${API_URL}/admission/${admissionId}`);
    return response.data;
  } catch (error) {
    if (
      error.response?.status === 500 &&
      (error.response?.data?.message?.includes("Failed to retrieve") ||
        error.response?.data?.message?.includes("from table") ||
        error.response?.data?.message?.includes("does not exist"))
    ) {
      return [];
    }
    throw error;
  }
};

export default {
  createCare,
  getNursingByAdmissionId,
}